import * as DateF from 'date-fns'
import React from 'react'
import styled, { css } from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { DATE_FORMAT } from '@root/shared'

import type BigNumber from 'bignumber.js'

export const LeaderboardRow: React.FC<{
  date: Date
  name: string
  profit: BigNumber
  currencyTicker: string
  rank: number
  darkBg?: boolean
  highlighted?: boolean
}> = ({ date, name, rank, profit, currencyTicker, highlighted = false }) => {
  return (
    <RowRoot>
      <Rank>{rank}.</Rank>
      <PrimaryText>{name}</PrimaryText>
      <SecondaryText>{DateF.format(date, DATE_FORMAT.dd_MM_yy)}</SecondaryText>
      <PrimaryText
        css={css`
          text-align: right;
        `}
      >
        <Numeric
          value={profit}
          currency={currencyTicker}
          preset="currency-amount-short"
        />
      </PrimaryText>

      {highlighted ? <Highlight /> : undefined}
    </RowRoot>
  )
}

export const RowRoot = styled.div`
  height: 40px;
  display: grid;
  grid-template-columns: 20px minmax(0, 1.5fr) minmax(0, 1fr) minmax(0, 1fr);
  grid-gap: 4px;
  align-items: center;
  padding-inline: 12px;
  position: relative;

  &:nth-child(even) {
    background: var(--appearance-1);
  }
  &:nth-child(odd) {
    border-bottom: 1px solid var(--backgroundA-2);
  }
`

const PrimaryText = styled.div`
  color: var(--text-12);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`

const SecondaryText = styled.div`
  color: var(--text-9);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`

const Rank = styled.div`
  color: var(--text-7);
  font-size: 10px;
  font-weight: 600;
  line-height: 12px;
`

const HighlightFrame = React.memo(() => {
  const width = window.innerWidth - 4
  const height = 36

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      css={css`
        position: absolute;
        inset: 2px 2px;
      `}
    >
      <rect
        x="0.5"
        y="0.5"
        width={width - 1}
        height={height - 1}
        rx="9.5"
        stroke="url(#paint0_radial_3255_42097)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_3255_42097"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-50.7391 -16.5) rotate(8.8847) scale(475.893 154.197)"
        >
          <stop stopColor="#5F97FF" />
          <stop offset="1" stopColor="#003699" />
        </radialGradient>
      </defs>
    </svg>
  )
})
HighlightFrame.displayName = 'HighlightFrame'

const Highlight = styled(HighlightFrame)`
  position: absolute;
  inset: 2px 4px;
`
